import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./style.scss";
import { dsnCN } from "../../hooks/helper";

function ContactForm({ className }) {
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setSent(false);
    setLoading(true);

    emailjs
      .sendForm(
        "service_0jmg95b",
        "template_6sfw05r",
        form.current,
        "bwGZZLWQUBLHJddhq",
      )
      .then(
        (res) => {
          console.log("Email sent", res);
          setLoading(false);
          setSent(true);
          form.current.reset();

          setTimeout(() => setSent(false), 5000);
        },
        (err) => {
          console.log("Email send failed", err);
          setLoading(false);
          setSent(false);
        },
      );
  };

  return (
    <div className={dsnCN("form-box", className)}>
      <h3 className="mb-30">Write A Comment</h3>
      <form ref={form} onSubmit={sendEmail}>
        <div className="input__wrap controls">
          <div className="form-group">
            <label>By what name are you known?</label>
            <input type="text" name="name" placeholder="Your name" required />
          </div>

          <div className="form-group">
            <label>Where shall my reply find you?</label>
            <input
              type="email"
              name="email"
              placeholder="Your Email Address"
              required
            />
          </div>

          <div className="form-group">
            <textarea
              name="message"
              placeholder="Speak your mind, and write what must be said."
              required
            />
          </div>

          <div className="image-zoom">
            <button type="submit">
              {loading ? "Sending..." : "Send Message"}
            </button>
          </div>

          {loading && <div className="loading-message mt-20">Sending...</div>}
          {sent && <div className="success-message mt-20">Message Sent!</div>}
        </div>
      </form>
    </div>
  );
}

export default ContactForm;
